const config = {
  BASE_URL: "https://api.utmanagement.outsite.app",
  BASE_URL_DEV: "https://dev.api.utmanagement.outsite.app",
  ATS_BASE_URL: "https://utwente.recruitment.outsite.app",
  ATS_BASE_URL_DEV: "https://utwente.dev-recruitment.outsite.app",
};

export default config;
